import { Box } from '@chakra-ui/react'
import { EventList } from '@src/components/sco/Events/EventList'
import { EventsPage } from '@src/components/sco/Events/EventsLayout'
import { EventsMainPanel } from '@src/components/sco/Events/EventsLayout/EventsMainPanel.tsx'
import { EventsPageHeader } from '@src/components/sco/Events/EventsPageHeader'
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'

export { getServerSideProps } from '@src/lib/server-side-rendering'

export default EventsPage(function Page() {
  const activeContent = useActiveContentContext()
  const { getBreakpointValue } = useBreakpointContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('events.workshops')
    activeContent.setBreadcrumbs([
      {
        title: 'Events',
        href: '/events',
      },
      {
        title: 'Workshops',
        href: '/events/workshops',
      },
    ])
  })

  return (
    <EventsMainPanel>
      <Box
        marginX={'auto'}
        maxWidth={'1480px'}
        padding={getBreakpointValue(['1em', '1em', '2em'])}
        width={'full'}
      >
        <EventsPageHeader title={'Upcoming Workshops'} />
        <EventList
          allowLoadMore={true}
          isFuture={true}
          typeKeys={['workshop']}
          order={[
            ['startsAt', 'ASC'],
            ['title', 'ASC'],
          ]}
        />
      </Box>
    </EventsMainPanel>
  )
})
